
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import OrderedCheckBox from "@/components/utils/PopulateForms/components/OrderedCheckBox.vue";
import { nameInfoType, otherPartyInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { form29InformationDataInfoType, enfrcOtherPartyDataInfoType } from '@/types/Application/AgreementEnforcement/PDF';
import { requiredDocumentsInfoType } from '@/types/Common';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        OrderedCheckBox        
    }
})

export default class Form29Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;
    
    @applicationState.State
    public requiredDocuments!: requiredDocumentsInfoType;    

    dataReady = false;   
    
    otherPartyInfo: enfrcOtherPartyDataInfoType[] = [];
    additionalOtherParties: enfrcOtherPartyDataInfoType[] = [];
    firstOtherParty = {} as enfrcOtherPartyDataInfoType;
    yourInfo = {} as yourInformationInfoDataInfoType;
    form29Info = {} as form29InformationDataInfoType;
    
    existingFileNumber = ''; 
    fmepNumber = '';

    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){
               
        this.otherPartyInfo=this.getOtherPartyInfo()        
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0,1)
            this.additionalOtherParties = this.otherPartyInfo;
        }        
        
        this.yourInfo = this.getYourInfo();
        this.form29Info = this.getForm29Info();
        this.existingFileNumber = getLocationInfo(this.result.filingLocationSurvey);
        this.fmepNumber = this.getFmepInfo(this.result.filingLocationSurvey);
    } 


    public getFmepInfo(locationData){
        return locationData?.ExistingFMEPCase  && locationData?.ExistingFMEPCase =='y' && locationData.ExistingFMEPNumber? locationData.ExistingFMEPNumber:'';        
    }

    public getYourInfo(){           

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation: enfrcOtherPartyDataInfoType[] = [];        

        if (this.result.otherPartyCommonSurvey?.length > 0){
            OpInformation = [];
            const otherPartyData: otherPartyInfoType[] =  this.result.otherPartyCommonSurvey;
           
            for(const party of otherPartyData){ 
                const otherParty = {} as enfrcOtherPartyDataInfoType;               

                if (party.knowDob == 'y' &&  party.dob)
                    otherParty.dob = party.dob

                if (party.name)
                    otherParty.name = party.name;
                
                if (party.address)
                    otherParty.address = party.address;
                
                if (party.contactInfo)
                    otherParty.contactInfo = party.contactInfo;

                if (party.lawyer)
                    otherParty.lawyer = party.lawyer
                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    }  
    
    public getForm29Info() {

        const form29Information = {} as form29InformationDataInfoType;
        form29Information.orderList = [];
        form29Information.expenseList = [];
        form29Information.arrearsDate = '';
        form29Information.foreignNotice = false;
        form29Information.otherPartyNotice = false;
        form29Information.attachRequiredDocuments = false;

        if (this.result?.enfrcQuestionnaireSurvey) {
            const enfrcQuest = this.result.enfrcQuestionnaireSurvey;
            if (enfrcQuest.includes('parentingCoordinatorDetermination')){

                form29Information.orderList.push('determination')
                if (this.result.enforceChangeSetAsideDeterminationSurvey){
                    form29Information.determinationDate = Vue.filter('beautify-date')(this.result.enforceChangeSetAsideDeterminationSurvey.existingDate);
                }    

            }

            if (enfrcQuest.includes('writtenAgreementOrder') && this.result.enforceAgreementOrOrderSurvey) {
                form29Information.orderList.push('writtenAgreementOrder');
                form29Information.writtenAgreementOrderDate = Vue.filter('beautify-date')(this.result.enforceAgreementOrOrderSurvey.existingDate);
            }

            if (enfrcQuest.includes('arrears') && this.result.detrermineArrearsSurvey){                
                form29Information.orderList.push('arrears');
                form29Information.arrearsDate = Vue.filter('beautify-date')(this.result.detrermineArrearsSurvey.existingDate);
            }

            if (enfrcQuest.includes('expenses') && this.result?.determineAnAmountOwingForExpensesSurvey?.amountOwingActionType){
                form29Information.orderList.push('expenses');                
                form29Information.expenseList = this.result.determineAnAmountOwingForExpensesSurvey.amountOwingActionType;
            }

            if (enfrcQuest.includes('foreignSupport') || this.requiredDocuments?.agreementEnfrc?.required?.length>0){
                form29Information.attachRequiredDocuments = true;
            }
            
            if (enfrcQuest.includes('foreignSupport')){
                form29Information.orderList.push('foreignSupport');              
            }

            if(enfrcQuest.includes('foreignSupport') && enfrcQuest.length==1){
                form29Information.otherPartyNotice = false;
                form29Information.foreignNotice = true;
            }else if(this.result?.otherPartyCommonConfirmationSurvey?.confirmation == "Confirmed")
            {
                form29Information.otherPartyNotice = true;
            }         
        }

        if (this.result.aboutTheOrderEnforcementSurvey) {

            const abtOrdrEnfrc = this.result.aboutTheOrderEnforcementSurvey;
            
            form29Information.facts = abtOrdrEnfrc.applicationFacts;            
            form29Information.orderdesc = abtOrdrEnfrc.orderDescription;
        } 
       
        return form29Information;
    }
 
}

